export default __webpack_public_path__ + "176f14c8c55893fcf448baf93aff523e.svg";